import i18next, { type i18n } from "i18next";
import * as z from "zod";
import { makeZodI18nMap } from "zod-i18n-map";

import zodEn from "zod-i18n-map/locales/en/zod.json";
import zodFr from "zod-i18n-map/locales/fr/zod.json";

let INSTANCE: i18n;

export function setLocale(locale: string) {
	if (!INSTANCE) {
		console.warn("[Form] I18n module not initialised.");
		return;
	}

	let lang: string | undefined;
	if (/fr/.test(locale)) {
		lang = "fr";
	} else if (/en/.test(locale)) {
		lang = "en";
	}

	if (!lang) {
		console.warn("[Form] invalid locale");
		return;
	}

	INSTANCE.changeLanguage(lang, (e) => {
		if (e) {
			console.warn("[Form] failed to load locale", e);
		}
	});
}

export function initI18n() {
	if (INSTANCE) return;

	INSTANCE = i18next.createInstance({
		lng: "en",
		ns: ["zod"],
		initImmediate: false,
		resources: {
			en: { zod: zodEn },
			fr: { zod: zodFr },
		},
	});
	INSTANCE.init();

	const { t } = INSTANCE;

	z.setErrorMap(makeZodI18nMap({ t }));
}
